/**
 * 项目页（S04）：列表为种子数据（S06 接真实接口），
 * 页面里放一张健康检查卡，全链路验证「登录 → callFunction → api → REST → PG」。
 */

import { Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import { callApi, ApiError } from "../lib/api";
import { useProject } from "../lib/project";
import { AsyncBoundary } from "../components/AsyncBoundary";
import { Card, Descriptions, Tag } from "antd";

interface HealthData {
  db: string;
  dbDetail: { status?: number; error?: string };
  version: string;
  node: string;
}

export function ProjectsPage() {
  const { projects, projectId } = useProject();

  const health = useQuery({
    queryKey: ["health"],
    queryFn: async () => (await callApi<HealthData>("/api/health")).data,
    retry: 1,
  });

  const current = projects.find((p) => p.id === projectId);

  return (
    <div>
      <Typography.Title level={4}>项目</Typography.Title>
      <Card title="平台健康检查（GET /api/health）" style={{ maxWidth: 640, marginBottom: 24 }}>
        <AsyncBoundary
          loading={health.isLoading}
          error={health.error}
          onRetry={() => health.refetch()}
          empty={false}
        >
          {health.data && (
            <Descriptions column={1} size="small">
              <Descriptions.Item label="数据通道">
                {health.data.db === "ok" ? (
                  <Tag color="success">ok（PostgREST 通道连通）</Tag>
                ) : (
                  <Tag color="error">{health.data.db}</Tag>
                )}
              </Descriptions.Item>
              <Descriptions.Item label="api 版本">{health.data.version}</Descriptions.Item>
              <Descriptions.Item label="运行时">{health.data.node}</Descriptions.Item>
            </Descriptions>
          )}
        </AsyncBoundary>
      </Card>
      <Card title="项目列表" style={{ maxWidth: 640 }}>
        <AsyncBoundary loading={false} empty={projects.length === 0} emptyText="还没有项目">
          <ul>
            {projects.map((p) => (
              <li key={p.id}>
                {p.name}
                {p.id === projectId && <Tag color="blue" style={{ marginLeft: 8 }}>当前</Tag>}
                {p.id === current?.id && p.id !== projectId && null}
              </li>
            ))}
          </ul>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            项目 CRUD 与资产接口在 S06 落地，当前为本地种子数据。
          </Typography.Text>
        </AsyncBoundary>
      </Card>
    </div>
  );
}

export function projectsQueryErrorInfo(e: unknown): string {
  return e instanceof ApiError ? `code=${e.code} traceId=${e.traceId}` : String(e);
}
